import { getFetchError } from '@/reducers/fetch'
import { Alert } from '@/ui'
import { useReselector } from '@/utils/sharedHooks'

export const PayrollError = ({ fetchKey }: { fetchKey: string }) => {
  const error = useReselector(getFetchError, fetchKey)

  if (!error) {
    return null
  }

  return (
    <Alert variant="error" className="mt-4">
      {error.message}
    </Alert>
  )
}
